module.exports = __webpack_public_path__ + "static/media/emma_inscripcion_cierre.e481007c.png";